import React, { FC } from 'react';
import { Navigate, Route, Routes as RRoutes } from 'react-router-dom';
import { TacticBoard } from '../TacticBoard';
import { AuthPage } from '../auth/AuthPage';
import { PurchaseCompletePage } from '../purchase/PurchaseCompletePage';
import { PurchasePage } from '../purchase/PurchasePage';
import { useAuthContext } from '../AuthProvider';
import { SplashScreen } from '../SplashScreen';
import { ProtectedRoute } from '../auth/ProtectedRoute';
import { PlannerPage } from '../planner/PlannerPage';

export const Routes: FC = () => {
  const { loading } = useAuthContext();

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <RRoutes>
      <Route
        index
        path={'/'}
        element={
          <ProtectedRoute subscriptionRequired={true}>
            <TacticBoard />
          </ProtectedRoute>
        }
      />
      <Route path={'/auth'} element={<AuthPage />} />
      <Route path={'/purchase-complete'} element={<PurchaseCompletePage />} />
      <Route
        path={'/subscribe'}
        element={
          <ProtectedRoute redirectIfSubscribed={true}>
            <PurchasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path={'/planner'}
        element={
          <ProtectedRoute proRequired={true}>
            <PlannerPage />
          </ProtectedRoute>
        }
      />
      <Route path={'*'} element={<Navigate to={'/'} replace={true} />} />
    </RRoutes>
  );
};
